// extracted by mini-css-extract-plugin
export default {"form":"vRC5ShSVTSVVebb0C_RY","title":"T5XCkipOVsx01UVdMX6g","row":"dKHYxQU8RjiA0caglM5G","subForm":"YYdQXdvjdnHtx_fjuObm"};